// All over the file changes has been done by Dev srini on 07/08/24

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { withStyles } from '@material-ui/core/styles'
import { Checkbox, FormControlLabel, Button,Grid,Typography } from '@material-ui/core'
import { useState,useEffect } from 'react'
import styles from './FilterStyles'

const FilterButtons = ({
    classes, allKycData, selectedStatus, handlecheckboxChange //dev-trupti on 26-11-2024
}) => {
    console.log()
    console.log("allKycData", allKycData)
   
    
    const completed = allKycData?.filter((r) => r.kyc_status === "completed").length;
    const inComplete = allKycData?.filter((r) => r.kyc_status === "in_progress").length;
    const boPending = allKycData?.filter((r) => r.kyc_status === "completed_bo_pending").length;
    const docVerification = allKycData?.filter((r) => r.kyc_status === "document_verification").length;
    const totalCount = completed + inComplete + boPending + docVerification;


    return (
        <div style={{ display: 'flex', width: '100%' }}>

            <Grid
                container
                spacing={2}
                justifyContent="flex-start"
                style={{ marginBottom: 16, width: "100%" }}
            >
                <Grid item>
                    <div className={classes.summaryBox}>
                        <div className={classes.summaryTitle}>Total</div>
                        <div className={classes.summaryValue}>{totalCount}</div>
                    </div>
                </Grid>
                <Grid item>
                    <div
                        className={classes.summaryBox}
                        style={{
                            backgroundColor: selectedStatus === "in_progress" ? "#fffbe7" : "",
                            cursor: "pointer",
                        }}
                        onClick={(e) => {
                            handlecheckboxChange(e, "in_progress")
                            
                        }}
                    >
                        <div
                            className={classes.summaryTitle}
                            
                        >
                            Inprogress
                        </div>
                        <div className={classes.summaryValue}>{inComplete}</div>
                    </div>
                </Grid>
                <Grid item>
                    <div
                        className={classes.summaryBox}
                        style={{
                            backgroundColor: selectedStatus === "document_verification" ? "#fffbe7" : "",
                            cursor: "pointer",
                        }}
                        onClick={(e) => {
                            handlecheckboxChange(e, "document_verification")
                            
                        }}
                    >
                        <div
                            className={classes.summaryTitle}
                            
                        >
                            Document Verification
                           
                        </div>
                        <div className={classes.summaryValue}>{docVerification}</div>
                    </div>
                    
                </Grid>
                <Grid item>
                    <div
                        className={classes.summaryBox}
                        style={{
                            backgroundColor: selectedStatus === "completed_bo_pending" ? "#fffbe7" : "",
                            cursor: "pointer",
                        }}
                        onClick={(e) => {
                            handlecheckboxChange(e, "completed_bo_pending")

                        }}
                    >
                        <div
                            className={classes.summaryTitle}

                        >
                            BO Pending
                        </div>
                        <div className={classes.summaryValue}>{boPending}</div>
                    </div>
                </Grid>
                <Grid item>
                    <div
                        className={classes.summaryBox}
                        style={{
                            backgroundColor:
                                selectedStatus === "completed"
                                    ? "#fffbe7"
                                    : "",
                            cursor: "pointer",
                        }}
                        onClick={(e) => {
                            handlecheckboxChange(e, "completed")

                        }}
                    >
                        <div
                            className={classes.summaryTitle}

                        >
                            Completed

                        </div>
                        <div className={classes.summaryValue}>{completed}</div>
                    </div>
                </Grid>
            </Grid>
          
        </div>
    )
}

export default withStyles(styles)(FilterButtons)
